// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dialog Title */

/* Dialog Content */
mat-dialog-content {
  min-width: 1000px;
  padding: 2px 24px !important;
  padding-bottom: 0px !important;
  background-color: #f0f0f0;
  overflow: auto;
  color: #000;
}

/* Before report generation */
.report-empty {
  min-height: auto !important;
  max-height: -moz-fit-content !important;
  max-height: fit-content !important;
}

.content {
  padding: 16px;
  border-radius: 4px;
  color: #000;
}

/* Dialog Actions */
mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

/* ── Page wrapper ──────────────────────────────────────────────────── */
.report-page {
  padding: 14px 18px;
  background: #fff;
  min-height: 100%;
}

/* ── Filter rows ───────────────────────────────────────────────────── */
.filter-row {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 10px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-label {
  font-size: 16px;
  white-space: nowrap;
  color: #6b6d6f;
  font-weight: 700;
}

.filter-group .form-control {
  font-size: 16px;
  line-height: 1.5;
  color: #495057;
  font-weight: 400;
}

.date-input {
  width: 140px;
}

.time-input {
  width: 76px;
  text-align: center;
}

.project-select {
  width: 330px;
}

/* Suppress the › arrow from NextPage btn::after */
.btn::after {
  content: '' !important;
  display: none !important;
}

/* ── Error banner ──────────────────────────────────────────────────── */
.error-banner {
  font-size: 13px;
  max-width: 600px;
}

/* ── Report region ─────────────────────────────────────────────────── */
.report-region {
  margin-top: 6px;
}

.report-heading-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.report-title {
  font-size: 20px;
  color: #000;
}

/* ── Report content wrapper (each report) ──────────────────────────── */
.report-content-wrapper {
  margin-bottom: 20px;
  page-break-after: always;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
}

/* ── Header table ──────────────────────────────────────────────────── */
.header-table {
  width: 100%;
  font-size: 11px;
  margin-bottom: 8px;
}

/* ── Mix section ───────────────────────────────────────────────────── */
.mix-section {
  margin-bottom: 12px;
  page-break-inside: avoid;
}

.test-table .bg-green {
  background-color: #b2cc34;
  text-align: center;
  font-weight: bold;
}

.test-table .bg-cyan {
  background-color: #00b2bd;
  text-align: center;
  font-weight: bold;
  color: #000;
}

.test-table .bg-orange {
  background-color: #faab18;
}

.rheology-table th {
  text-align: center;
  font-weight: bold;
}

.test-table thead tr.bg-red>th,
.rheology-table thead tr.bg-red>th {
  background-color: #e21836;
}

.test-table thead tr.bg-gray>th,
.rheology-table thead tr.bg-gray>th {
  background-color: #ba3093;
}

.test-table tr.bg-blue>th {
  background-color: #009DD9;
}

.test-table td,
.rheology-table td {
  text-align: center;
  border: 1px solid #000;
}

.test-table th,
.rheology-table th {
  text-align: center;
  border: 1px solid #000;
}

.tables-container {
  display: flex;
  width: 100%;
  gap: 0;
}

.table-wrapper {
  width: 50%;
}

.test-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.empty-table {
  width: 100%;
  min-height: 120px;
  border: 1px solid #000;
}

/* ── Highlight rows ────────────────────────────────────────────────── */
.highlight-yellow {
  background: #FFFF99 !important;
}

/* ── Status / loading text ─────────────────────────────────────────── */
.status-text {
  font-size: 13px;
  color: #6B6D6F;
  padding: 6px 0;
}

.custom-mix-table {
  width: 100%;
  max-width: 100%;
  border: 1px solid #000;
  border-collapse: collapse;
  font-size: 14px;
  background-color: #FAAB18;
  table-layout: auto;
  box-sizing: border-box;
}

.custom-mix-table td {
  border: none;
  padding: 6px 8px;
  vertical-align: top;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: normal;
}

/* ── Notes section (Yellow background) ─────────────────────────────── */
.bg-yellow {
  background: #FAAB18;
}

.notes-section {
  padding: 4px;
  border: 1px solid #000;
  margin-bottom: 4px;
  font-size: 12px;
}

.inline-item {
  display: inline;
  margin-right: 5px;
  white-space: normal;
}

.mixability-row td {
  border-bottom: 1px solid #000 !important;
}

.summary-report-titlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px 6px 16px;
  margin: -24px -24px 12px -24px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  font-weight: 600;
  font-size: 16px;
  -webkit-user-select: none;
          user-select: none;
}

.summary-report-titlebar .title-text {
  flex: 1;
}

.summary-report-titlebar .window-controls {
  display: inline-flex;
  gap: 2px;
}

.summary-report-titlebar .win-btn {
  background: transparent;
  border: none;
  width: 34px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px;
  color: #333;
}

.summary-report-titlebar .win-btn:hover {
  background: #e5e5e5;
}

.summary-report-titlebar .win-btn.win-close:hover {
  background: #e81123;
  color: #fff;
}

.summary-report-titlebar .win-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}

::ng-deep .cdk-overlay-pane.summary-report-maximized {
  max-width: 100vw !important;
  max-height: 100vh !important;
  width: 100vw !important;
  height: 100vh !important;
}

::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-container,
::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-surface,
::ng-deep .cdk-overlay-pane.summary-report-maximized .mdc-dialog__surface {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
}

::ng-deep .cdk-overlay-pane.summary-report-maximized mat-dialog-content,
::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-content {
  max-width: none !important;
  min-width: 0 !important;
  width: 100% !important;
  max-height: none !important;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/summary-report-by-date/summary-report-by-date.component.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,mBAAmB;AACnB;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,uCAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,MAAM;AACR;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,8BAA8B;AAChC;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":["/* Dialog Title */\n\n/* Dialog Content */\nmat-dialog-content {\n  min-width: 1000px;\n  padding: 2px 24px !important;\n  padding-bottom: 0px !important;\n  background-color: #f0f0f0;\n  overflow: auto;\n  color: #000;\n}\n\n/* Before report generation */\n.report-empty {\n  min-height: auto !important;\n  max-height: fit-content !important;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n  color: #000;\n}\n\n/* Dialog Actions */\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n/* ── Page wrapper ──────────────────────────────────────────────────── */\n.report-page {\n  padding: 14px 18px;\n  background: #fff;\n  min-height: 100%;\n}\n\n/* ── Filter rows ───────────────────────────────────────────────────── */\n.filter-row {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  margin-bottom: 10px;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.filter-label {\n  font-size: 16px;\n  white-space: nowrap;\n  color: #6b6d6f;\n  font-weight: 700;\n}\n\n.filter-group .form-control {\n  font-size: 16px;\n  line-height: 1.5;\n  color: #495057;\n  font-weight: 400;\n}\n\n.date-input {\n  width: 140px;\n}\n\n.time-input {\n  width: 76px;\n  text-align: center;\n}\n\n.project-select {\n  width: 330px;\n}\n\n/* Suppress the › arrow from NextPage btn::after */\n.btn::after {\n  content: '' !important;\n  display: none !important;\n}\n\n/* ── Error banner ──────────────────────────────────────────────────── */\n.error-banner {\n  font-size: 13px;\n  max-width: 600px;\n}\n\n/* ── Report region ─────────────────────────────────────────────────── */\n.report-region {\n  margin-top: 6px;\n}\n\n.report-heading-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.report-title {\n  font-size: 20px;\n  color: #000;\n}\n\n/* ── Report content wrapper (each report) ──────────────────────────── */\n.report-content-wrapper {\n  margin-bottom: 20px;\n  page-break-after: always;\n  max-width: 100%;\n  overflow-x: auto;\n  box-sizing: border-box;\n}\n\n/* ── Header table ──────────────────────────────────────────────────── */\n.header-table {\n  width: 100%;\n  font-size: 11px;\n  margin-bottom: 8px;\n}\n\n/* ── Mix section ───────────────────────────────────────────────────── */\n.mix-section {\n  margin-bottom: 12px;\n  page-break-inside: avoid;\n}\n\n.test-table .bg-green {\n  background-color: #b2cc34;\n  text-align: center;\n  font-weight: bold;\n}\n\n.test-table .bg-cyan {\n  background-color: #00b2bd;\n  text-align: center;\n  font-weight: bold;\n  color: #000;\n}\n\n.test-table .bg-orange {\n  background-color: #faab18;\n}\n\n.rheology-table th {\n  text-align: center;\n  font-weight: bold;\n}\n\n.test-table thead tr.bg-red>th,\n.rheology-table thead tr.bg-red>th {\n  background-color: #e21836;\n}\n\n.test-table thead tr.bg-gray>th,\n.rheology-table thead tr.bg-gray>th {\n  background-color: #ba3093;\n}\n\n.test-table tr.bg-blue>th {\n  background-color: #009DD9;\n}\n\n.test-table td,\n.rheology-table td {\n  text-align: center;\n  border: 1px solid #000;\n}\n\n.test-table th,\n.rheology-table th {\n  text-align: center;\n  border: 1px solid #000;\n}\n\n.tables-container {\n  display: flex;\n  width: 100%;\n  gap: 0;\n}\n\n.table-wrapper {\n  width: 50%;\n}\n\n.test-table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #000;\n}\n\n.empty-table {\n  width: 100%;\n  min-height: 120px;\n  border: 1px solid #000;\n}\n\n/* ── Highlight rows ────────────────────────────────────────────────── */\n.highlight-yellow {\n  background: #FFFF99 !important;\n}\n\n/* ── Status / loading text ─────────────────────────────────────────── */\n.status-text {\n  font-size: 13px;\n  color: #6B6D6F;\n  padding: 6px 0;\n}\n\n.custom-mix-table {\n  width: 100%;\n  max-width: 100%;\n  border: 1px solid #000;\n  border-collapse: collapse;\n  font-size: 14px;\n  background-color: #FAAB18;\n  table-layout: auto;\n  box-sizing: border-box;\n}\n\n.custom-mix-table td {\n  border: none;\n  padding: 6px 8px;\n  vertical-align: top;\n  line-height: 1.4;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: normal;\n}\n\n/* ── Notes section (Yellow background) ─────────────────────────────── */\n.bg-yellow {\n  background: #FAAB18;\n}\n\n.notes-section {\n  padding: 4px;\n  border: 1px solid #000;\n  margin-bottom: 4px;\n  font-size: 12px;\n}\n\n.inline-item {\n  display: inline;\n  margin-right: 5px;\n  white-space: normal;\n}\n\n.mixability-row td {\n  border-bottom: 1px solid #000 !important;\n}\n\n.summary-report-titlebar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 12px 6px 16px;\n  margin: -24px -24px 12px -24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n  font-weight: 600;\n  font-size: 16px;\n  user-select: none;\n}\n\n.summary-report-titlebar .title-text {\n  flex: 1;\n}\n\n.summary-report-titlebar .window-controls {\n  display: inline-flex;\n  gap: 2px;\n}\n\n.summary-report-titlebar .win-btn {\n  background: transparent;\n  border: none;\n  width: 34px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 2px;\n  color: #333;\n}\n\n.summary-report-titlebar .win-btn:hover {\n  background: #e5e5e5;\n}\n\n.summary-report-titlebar .win-btn.win-close:hover {\n  background: #e81123;\n  color: #fff;\n}\n\n.summary-report-titlebar .win-btn mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n\n::ng-deep .cdk-overlay-pane.summary-report-maximized {\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  width: 100vw !important;\n  height: 100vh !important;\n}\n\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-container,\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-surface,\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mdc-dialog__surface {\n  width: 100vw !important;\n  height: 100vh !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  border-radius: 0 !important;\n}\n\n::ng-deep .cdk-overlay-pane.summary-report-maximized mat-dialog-content,\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-content {\n  max-width: none !important;\n  min-width: 0 !important;\n  width: 100% !important;\n  max-height: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
